// extracted by mini-css-extract-plugin
module.exports = {"Button":"t_rC q_rC q_rp g_fl g_fz g_fp g_g9","full":"t_sm g_dl g_dw","width100":"t_dl g_dl","design3Pos":"t_sn g_dQ"};